import request from "@/utils/request";

export default function getCardInfoByCardNumTop(cardId) {
    return request({
        url: `/user/card/getCardInfoByCardNum?id=${cardId}`,
    })
}
